import React, { useState } from 'react';
import { api } from '../utils/api';
import { useNavigate } from 'react-router-dom';

export default function Import() {
  const [step, setStep] = useState(1);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [mapping, setMapping] = useState({});
  const [importing, setImporting] = useState(false);
  const [results, setResults] = useState(null);
  const navigate = useNavigate();

  const handleFile = async (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setFile(f);
    const d = await api.previewCSV(f);
    if (d.error) { alert(d.error); return; }
    setPreview(d);
    setMapping(d.mapping);
    setStep(2);
  };

  const runImport = async () => {
    setStep(3);
    setImporting(true);
    const d = await api.importCSV(file, mapping);
    setImporting(false);
    setResults(d);
    setStep(4);
  };

  const fields = { vin:'VIN', year:'Year', make:'Make', model:'Model', trim:'Trim', mileage:'Mileage', price:'Price', down_payment:'Down Payment', weekly_payment:'Weekly Payment', color_exterior:'Exterior Color', color_interior:'Interior Color', transmission:'Transmission', engine:'Engine', body_style:'Body Style', photos:'Photos' };

  return (
    <div>
      <div className="page-header"><h1>Import <span>Inventory</span></h1></div>
      <p style={{ color: '#888', marginBottom: 24, fontSize: 14 }}>Import vehicles from any dealer management system. Upload a CSV export and we will automatically map the columns.</p>

      {step === 1 && (
        <div>
          <div className="photo-upload-area" onClick={() => document.getElementById('csv-input').click()}>
            <div style={{ fontSize: 32 }}>📄</div>
            <p style={{ color: '#666', marginTop: 8 }}>Click to select your CSV file</p>
            <p style={{ fontSize: 12, color: '#444', marginTop: 4 }}>Supports Wayne Reaves, Frazer, DealerSocket, and most DMS exports</p>
          </div>
          <input type="file" id="csv-input" accept=".csv" style={{ display: 'none' }} onChange={handleFile} />
        </div>
      )}

      {step === 2 && preview && (
        <div>
          <div style={{ background: '#1a1a1a', border: '1px solid #222', borderRadius: 10, padding: 20, marginBottom: 20 }}>
            <h3 style={{ color: '#cc0000', fontSize: 13, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 16 }}>Column Mapping</h3>
            <div className="form-grid">
              {Object.entries(fields).map(([field, label]) => (
                <div key={field} className="form-group">
                  <label>{label}</label>
                  <select value={mapping[field] || ''} onChange={e => setMapping(m => ({ ...m, [field]: e.target.value }))}>
                    <option value="">-- skip --</option>
                    {preview.headers.map(h => <option key={h} value={h}>{h}</option>)}
                  </select>
                </div>
              ))}
            </div>
          </div>
          <p style={{ color: '#888', fontSize: 13, marginBottom: 16 }}>{preview.total} vehicles found in CSV</p>
          <div style={{ display: 'flex', gap: 12 }}>
            <button className="btn-red" onClick={runImport}>Import Vehicles</button>
            <button className="btn-outline" onClick={() => setStep(1)}>Start Over</button>
          </div>
        </div>
      )}

      {step === 3 && (
        <div style={{ background: '#1a1a1a', border: '1px solid #333', borderRadius: 10, padding: 40, textAlign: 'center' }}>
          <div className="spinner" style={{ width: 32, height: 32, borderWidth: 3, margin: '0 auto 16px' }} />
          <p style={{ color: '#888' }}>Importing vehicles and downloading photos...</p>
          <p style={{ color: '#555', fontSize: 12, marginTop: 8 }}>This may take a few minutes</p>
        </div>
      )}

      {step === 4 && results && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16, marginBottom: 20 }}>
            <div className="stat-card red"><div className="label">Imported</div><div className="value">{results.success}</div></div>
            <div className="stat-card"><div className="label">Skipped</div><div className="value">{results.skipped}</div></div>
            <div className="stat-card"><div className="label">Failed</div><div className="value">{results.failed}</div></div>
          </div>
          <div style={{ display: 'flex', gap: 12 }}>
            <button className="btn-red" onClick={() => navigate('/inventory')}>View Inventory</button>
            <button className="btn-outline" onClick={() => { setStep(1); setFile(null); setPreview(null); setResults(null); }}>Import Another</button>
          </div>
        </div>
      )}
    </div>
  );
}
